module.exports = __webpack_public_path__ + "img/organisation.7afe2dd3.svg";